/**
 * CONFIDENTIAL AND PROPRIETARY SOURCE CODE.
 *
 * Use and distribution of this code is subject to applicable licenses and the
 * permission of the code owner. This notice does not indicate the actual or
 * intended publication of this source code.
 *
 * Portions developed for Bronner's Christmas by BTM Global Consulting LLC and are the
 * property of Bronner's Christmas.
 * =============================================================================
 * Version  Date          Author        Remarks
 * 1.0.0    08 Jul 2020   Tuan Le       BZ44750 - [Bronner] [PROD] Retail - Recently Viewed Not Always Visible
 */

define(
    'BTM.RecentlyViewedItemFixes.RecentlyViewedItemFixes'
    , [
        'BTM.RecentlyViewedItemFixes.RecentlyViewedItemFixes.View',
        'SC.Configuration',
        'underscore',
        'Utils'
    ]
    , function (
        RecentlyViewedItemFixesView,
        Configuration,
        _,
        Utils
    ) {
        'use strict';

        return {
            mountToApp: function mountToApp(container) {
                if (!Configuration.get('recentlyViewedItemFixes.enabled')) {
                    return;
                }
                var myMaxSlides = Configuration.get('recentlyViewedItemFixes.maxSlides') || 5;
                try {
                    var RecentlyViewedItemsView = require('RecentlyViewedItems.View');
                    var RecentlyViewedItemsCollection = require('RecentlyViewedItems.Collection');
                    if (RecentlyViewedItemsView) {
                        _.extend(RecentlyViewedItemsView.prototype, {
                            loadRecentlyViewedItem: function loadRecentlyViewedItem() {
                                const self = this;

                                RecentlyViewedItemsCollection.getInstance().turnOnTracking();

                                this.collection.promise &&
                                this.collection.promise.done(function () {
                                    const {application} = self.options;
                                    const number_of_items_displayed = Configuration.get('recentlyViewedItems.numberOfItemsDisplayed'); //BZ44750

                                    self.collection = self.collection.first(parseInt(number_of_items_displayed));
                                    self.render();

                                    const carousel = self.$el.find('[data-type="carousel-items"]');

                                    const {siteSettings, imageSizeMapping} = application.getConfig();
                                    if (Utils.isPhoneDevice() === false && siteSettings.imagesizes) {
                                        const thumbnail = _.where(siteSettings.imagesizes, {
                                            name: imageSizeMapping.thumbnail
                                        })[0];

                                        const img_min_height = thumbnail.maxheight;

                                        carousel
                                            .find('.item-relations-related-item-thumbnail')
                                            .css('minHeight', img_min_height);
                                    }

                                    Configuration.bxSliderDefaults.maxSlides = myMaxSlides; //BZ44750
                                    Utils.initBxSlider(carousel, Configuration.bxSliderDefaults);
                                });
                            }
                        });
                    }
                } catch (err) {
                }
                try {
                    var ItemRelationsCorrelatedView = require('ItemRelations.Correlated.View');
                    var Tracker = require('Tracker');
                    if (ItemRelationsCorrelatedView) {
                        _.extend(ItemRelationsCorrelatedView.prototype, {
                            loadRelatedItems: function loadRelatedItems() {
                                const self = this;

                                self.collection.fetchItems().done(function () {
                                    if (self.collection.length) {
                                        if (!self.view_tracked) {
                                            Tracker.getInstance().trackProductListEvent(
                                                self.collection,
                                                'Correlated Items'
                                            );
                                            self.view_tracked = true;
                                        }
                                    }

                                    self.render();

                                    const carousel = self.$el.find('[data-type="carousel-items"]');
                                    var config = self.options.application.getConfig();
                                    var siteSettings = config.siteSettings,
                                        imageSizeMapping = config.imageSizeMapping,
                                        bxSliderDefaults = config.bxSliderDefaults;

                                    if (Utils.isPhoneDevice() === false && siteSettings.imagesizes) {
                                        const img_min_height = (_.where(siteSettings.imagesizes, {
                                            name: imageSizeMapping.thumbnail
                                        })[0]).maxheight;

                                        carousel
                                            .find('.item-relations-related-item-thumbnail')
                                            .css('minHeight', img_min_height);
                                    }

                                    bxSliderDefaults.maxSlides = myMaxSlides; //BZ44750
                                    Utils.initBxSlider(carousel, bxSliderDefaults);
                                });
                            }
                        });
                    }
                } catch (err) {
                }
            }
        };
    });
